export default "__VITE_ASSET__BDZJTO6Y__"